import React, { useCallback } from 'react';
import '../../App.scss';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { APP_ROUTES } from '../../constants/appRoutes';
import logo from '../../assets/icons/logo.svg';
import forkdomLogo from '../../assets/icons/forkdom-logo.svg';

const Footer = () => {
  const { t } = useTranslation();

  const getCurrentYear = useCallback(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  }, []);

  return (
    <div className={styles.innerContainer}>
      <div className={styles.footerLeft}>
        <Link to={APP_ROUTES.MAIN_PAGE} className={styles.footerLink}>
          <img className={styles.logo} src={logo} alt="HeeBenor logo" />
          <p>HeeBenor</p>
        </Link>
        <span className={styles.verticalDivider} />
        <p className={styles.footerText}>
          {t('Copyright')} &#169; HeeBenor {getCurrentYear()}
        </p>
      </div>
      <span className={styles.horizontalDivider} />

      <Link
        className={styles.footerRight}
        target="_blank"
        to="https://forkdom.com/"
      >
        <p className={styles.footerText}>{t('Made by')} Forkdom Solutions</p>
        <div className={styles.logoWrapper}>
          <img
            className={styles.forkdomLogo}
            src={forkdomLogo}
            alt="Forkdom logo"
          />
        </div>
      </Link>
    </div>
  );
};

export default Footer;
